export class LabelRequestModel {
  enumFormattedLabelID: string;
  objectIds: string[] = [];
}
